import { Loader2, Pause, Play, RotateCcw } from "lucide-react";
import { fmtClock } from "@/lib/studioApi";

/** Play the preview, scrub, A/B the mastering tone, reset the balance. */
export default function MixTransport({ p, masterOn, onMasterOn, onReset, saveState }) {
  const pct = p.duration ? Math.min(100, (p.time / p.duration) * 100) : 0;
  const onSeek = (e) => {
    if (!p.duration) return;
    const r = e.currentTarget.getBoundingClientRect();
    p.seek(Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * p.duration);
  };
  return (
    <div data-testid="mix-transport" className="flex flex-wrap items-center gap-4 rounded-3xl border border-cyan-400/20 bg-cyan-500/[0.05] p-4">
      <button type="button" data-testid="mix-play" onClick={p.playing ? p.pause : p.play} disabled={p.state === "loading"} aria-label={p.playing ? "Pause" : "Play the mix"}
        className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-white text-[#05070f] transition-transform duration-200 hover:scale-105 disabled:opacity-50">
        {p.state === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : p.playing ? <Pause className="h-5 w-5" /> : <Play className="ml-0.5 h-5 w-5" />}
      </button>
      <div className="min-w-[200px] flex-1">
        <div role="slider" tabIndex={0} aria-label="Seek" aria-valuemin={0} aria-valuemax={Math.round(p.duration)} aria-valuenow={Math.round(p.time)}
          data-testid="mix-seek" onClick={onSeek} className="relative h-2 cursor-pointer rounded-full bg-white/10">
          <div className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-cyan-300 to-amber-300" style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-1 flex justify-between font-mono text-[10px] text-white/45"><span data-testid="mix-time">{fmtClock(p.time)}</span><span>{fmtClock(p.duration)}</span></div>
      </div>
      <button type="button" role="switch" aria-checked={masterOn} data-testid="mix-master-ab" onClick={() => onMasterOn(!masterOn)}
        className={`rounded-full border px-4 py-2 font-mono text-[10px] uppercase tracking-wider transition-colors duration-200 ${masterOn ? "border-amber-300/60 bg-amber-500/15 text-amber-100" : "border-white/12 text-white/55 hover:text-white"}`}>
        Mastering {masterOn ? "on" : "off"}
      </button>
      <button type="button" data-testid="mix-reset" onClick={onReset} className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-white/50 hover:text-white">
        <RotateCcw className="h-3.5 w-3.5" /> Reset mix
      </button>
      <span data-testid="mix-save-state" data-state={saveState} className="font-mono text-[10px] uppercase tracking-wider text-white/40">
        {saveState === "saving" ? "Saving…" : saveState === "error" ? "Not saved" : "Saved"}
      </span>
      {p.state === "error" ? <p className="w-full text-[12px] text-rose-300">The parts couldn't be loaded for the preview — you can still render the mix.</p> : null}
    </div>
  );
}
